import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import QueueService from "../../../../../services/QueueService/QueueService";
import {useSetRecoilState} from 'recoil';
import { alertState } from "../../../../../recoil-store/recoil-state";

const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: "#f2f2f2",
    color: "#d6d6d6",
  },
  bottomSection: {
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  formControl: {
    backgroundColor: "#F2F2F2 !important",
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  button: {
    border: "none",
    borderRadius: "5px",
    width: 100,
    height: 35,
    "&:focus": {
      outline: "none",
    },
  },
  submit: {
    color: "red",
    background: "transparent",
    border: "1px solid red",
    cursor: "pointer",
  },
}));

const WaitingQueueModal = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const handleClose = () => {
    props.setOpen(false);
  };
  const setAlert = useSetRecoilState(alertState);

  //this will add the default alert whenever you reload your page.
  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };
    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  // add autom queue list
  async function addQueueList() {
    const response = await QueueService.insertQueue(props.automDetail?.id, props.automDetail?.mate_id);
    if (response) {
      if (response?.status) {
        //success
        setAlert(alert => ({ ...alert, show: true, message: t("MESSAGES.MONITORING.QUEUE-SUCCESS"), severity: 'success' }));
      } else {
        //err
        setAlert(alert => ({ ...alert, show: true, message: t("MESSAGES.MONITORING.QUEUE-ERROR"), severity: 'error' }));
      }
    } else {
      //err
      setAlert(alert => ({ ...alert, show: true, message: t("MESSAGES.MONITORING.QUEUE-ERROR"), severity: 'error' }));
    }
    props.setOpen(false);
  }

  return (
    <Dialog id="autom-addNew-modal" data-test="autom-add-new" open={true}>
      <DialogTitle
        id="alert-dialog-title"
        style={{ backgroundColor: "#001128" }}
      >
        <div id="about-title">
          <b>{t('CONTENT.FLOW.RUN-FLOW-WAIT-QUEUE')}</b>
          <Button data-test="cancelautom-button" onClick={handleClose}>
            <b>{t("CONTENT.AUTOMS-LIST.CLOSE")}</b>
          </Button>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {t('CONTENT.FLOW.RUN-FLOW-QUEUE-MESSAGE-1')} <strong>{props.numberQueue} Autom</strong> {t('CONTENT.FLOW.RUN-FLOW-QUEUE-MESSAGE-2')}
            </Grid>
            <Grid item xs={12}>
              <button
                type="button"
                data-test="createautom-button"
                style={{ marginRight: "10px",border:"1px solid green",color:"green"}}
                onClick={() => addQueueList()}
                className={`${classes.button} ${classes.submit}`}
              >
                {t('CONTENT.FLOW.YES')}
              </button>
              <button
                type="button"
                data-test="createautom-button"
                onClick={() => handleClose()}
                className={`${classes.button} ${classes.submit}`}
              >
                {t('CONTENT.FLOW.NO')}
              </button>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: "space-between",
          padding: "8px 24px 16px 24px",
        }}
      ></DialogActions>
    </Dialog>
  );
};

export default WaitingQueueModal;
